/**
 * aiMonitor模块接口列表
 */
import $http from '../utils/http'; // 导入http中创建的axios实例

const aiMonitor = {
  // 创建
  createAiApplication(params) {
    return $http.post(`${global.API_URL}/sme/aiApplication/create`,params);
  },
  //删除
  deleteAiApplication(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/aiApplication/delete`,param);
  },
  //列表分页
  pageAiApplication(params) {
    return $http.post(`${global.API_URL}/sme/aiApplication/page`,params);
  },
  //改变状态
  changeStatus(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/aiApplication/changeStatus`,param);
  },
  queryAiApplications(params){
    return $http.post(`${global.API_URL}/sme/aiApplication/queryAiApplications`,params);
  },
  //根据应用ID查询仪表盘数据
  queryAiApplicationDashboard(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/aiApplication/queryAiApplicationDashboard`,param);
  }
}

export default aiMonitor;



// WEBPACK FOOTER //
// ./src/api/aiMonitor.js